import { useContext } from "react";
import { MyCompanyProfileContext } from "../MyCompanyProfileContext";
import { UserApiContext } from "../Components/UserDetailsContext/UserDetailsContext";

const useIsSuperAdmin = () => {
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { userDetails } = useContext(UserApiContext);
  const email = userDetails?.email?.toLowerCase();
  if (!companySettingData?.contact_information || !email) return false;
  const user = companySettingData.contact_information.find((u) => u.email?.toLowerCase() === email);
  return user?.super_admin === true;
};

export default useIsSuperAdmin;
